"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Deferred = function () {
    function Deferred() {
        var _this = this;

        _classCallCheck(this, Deferred);

        this.promise = new Promise(function (resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }

    _createClass(Deferred, [{
        key: "reject",
        get: function get() {
            return this._reject;
        }
    }, {
        key: "resolve",
        get: function get() {
            return this._resolve;
        }
    }]);

    return Deferred;
}();

exports.default = Deferred;
//# sourceMappingURL=Deferred.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@twilio/audioplayer/es5/Deferred.js
// module id = eYrn
// module chunks = 0